// client/src/services/businessProfileService.js
import api from './api.js';

export const businessProfileService = {
  // Get current user's profile + links
  getProfile: () => api.get('/business-profile'),

  // Create or update profile
  updateProfile: (data) => api.put('/business-profile', data),

  // Upload profile photo (file upload)
  uploadPhoto: async (file) => {
    const formData = new FormData();
    formData.append('photo', file);
    
    const token = localStorage.getItem('token');
    const response = await fetch('/api/business-profile/photo', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw { data: error };
    }
    
    return response.json();
  },

  // Remove profile photo
  removePhoto: () => api.del('/business-profile/photo'),

  // Add a CRM link
  addLink: (name, url) => api.post('/business-profile/links', { name, url }),

  // Update a CRM link
  updateLink: (linkid, data) => api.put(`/business-profile/links/${linkid}`, data),

  // Delete a CRM link
  deleteLink: (linkid) => api.del(`/business-profile/links/${linkid}`),

  // Get public profile (no auth required)
  getPublicProfile: (userid) => api.get(`/business-profile/public/${userid}`, false),

  // Track CRM link click (no auth required)
  trackLinkClick: (linkid, moonbeamid, recipientid) =>
    api.post(`/business-profile/links/${linkid}/click`, { moonbeamid, recipientid }, false),

  // Track admin CTA link click (no auth required)
  trackAdminLinkClick: (shortcode, moonbeamid, recipientid) =>
    api.post(`/business-profile/admin-link/${shortcode}/click`, { moonbeamid, recipientid }, false),
};

export default businessProfileService;